/* global wp_admin_ajax */

import AjaxUtils from '../utils/ajax';

export default function initProfil() {
    if (document.querySelector('.profil-page')) {
        new Profil(document.querySelector('.profil-page'));
    }
}

/**
 * @param {HTMLElement} $el HTML Element
 */
class Profil {
    constructor($el) {
        this.$el = $el;
        this.$formNotificationsPreferences = $el.querySelector('.js-form-notifications-preferences');
        this.$btnSubmitFormNotificationsPreferences = this.$formNotificationsPreferences.querySelector('button[type="submit"]');
        this.$formNotificationsPreferencesDatas = new FormData(this.$formNotificationsPreferences);
        this.$formNotificationsPreferencesUpdateMessage = this.$formNotificationsPreferences.querySelector('.button .message');
        this.$formImportPhoto = $el.querySelector('.js-import-photo');
        this.$inputFilePhoto = this.$formImportPhoto.querySelector('.js-file-photo');
        this.$btnImportPhoto = this.$formImportPhoto.querySelector('.js-btn-import-photo');
        this.$photoContainer = this.$formImportPhoto.querySelector('.js-photo');
        this.$photoSmallContainer = document.querySelector('.app-profile .js-photo-small');
        this.$btnDeletePhoto = this.$formImportPhoto.querySelector('.js-btn-delete-photo');
        this.init();
    }

    init() {
        this.$formNotificationsPreferences.addEventListener('change', (evt) => {
            evt.preventDefault();

            // On check si les pref de notifications ont changé
            const formDataCurrent = new FormData(this.$formNotificationsPreferences).getAll('notifications[]');
            const formDataOriginal = this.$formNotificationsPreferencesDatas.getAll('notifications[]');
            const formDatasIsEquals = (formDataCurrent.length === formDataOriginal.length && formDataCurrent.every((value, index) => value === formDataOriginal[index]));
            
            this.$btnSubmitFormNotificationsPreferences.disabled = formDatasIsEquals;
        });
       
        this.$formNotificationsPreferences.addEventListener('submit', (evt) => {
            evt.preventDefault();
            this.saveNotificationsPreferences(evt.target);
        });

        this.$btnImportPhoto.addEventListener('click', (evt) => {
            evt.preventDefault();
            this.$inputFilePhoto.click();
        });

        this.$inputFilePhoto.addEventListener('change', (evt) => {
            evt.preventDefault();

            // On limite l'upload à 2 mo
            const fileSize = (evt.target.files[0].size / 1048576).toFixed(1);
            const fileMaxSize = 2;
            
            if (fileSize > fileMaxSize) {
                return false;
            }

            const args = new FormData(this.$formImportPhoto);
            args.append('action', 'upload_photo_profil');

            AjaxUtils.postData(wp_admin_ajax, args).then(response => {
                if (response.success) {
                    this.$photoContainer.innerHTML = response.data.vignette;
                    this.$photoSmallContainer.innerHTML = response.data.vignette;
                    this.$btnDeletePhoto.classList.add('visible');
                }
            });
        });

        this.$btnDeletePhoto.addEventListener('click', (evt) => {
            evt.preventDefault();
            const btnDeletePhoto = evt.target;
            const args = new FormData();
            args.append('action', 'delete_photo_profil');

            AjaxUtils.postData(wp_admin_ajax, args).then(response => {
                if (response.success) {
                    this.$photoContainer.innerHTML = '';
                    this.$photoSmallContainer.innerHTML = '';
                    btnDeletePhoto.classList.remove('visible');
                }
            });
        });
    }
    
    saveNotificationsPreferences(form) {
        const args = new FormData(form);
        args.append('action', 'save_notifs_preferences');
        
        AjaxUtils.postData(wp_admin_ajax, args).then(response => {
            if (response.success) {
                this.$btnSubmitFormNotificationsPreferences.disabled = true;
                this.$formNotificationsPreferencesDatas = new FormData(form);
                this.$formNotificationsPreferencesUpdateMessage.classList.add('visible');
                const formNotificationsPreferencesUpdateMessage = this.$formNotificationsPreferencesUpdateMessage;
                setTimeout(function() {
                    formNotificationsPreferencesUpdateMessage.classList.remove('visible');
                }, 1000);
            }
        });
    }
}
